<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.user.full_name="{ header, data, value: v }">
      <router-link
        :to="header.getRoute(data)"
        v-text="v"
      />
    </template>

    <template #item.storage_file.filename="{ header, data, value: v }">
      <router-link
        :to="header.getRoute(data)"
        v-text="v"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/Publications/Storage/FilesHistory/table-headers'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTablePublicationStorageFilesHistory',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
